/* eslint-disable prettier/prettier */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaterialGrid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import SelectMultipleV4 from '../components/SelectMultipleV4';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import { InputEasyImageWithProcessing } from 'common/components/fields/InputEasyImageWithProcessing';
import { EditorConvertToHTMLActivity } from 'common/components/fields/EditorConvertToHTMLActivity';
import { FORM_RULES } from 'helpers/validations';
import { BASE_S3 } from 'config/consts';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { getList as getCategoriesList } from '../../../categories/categoriesActions';
import ImageCropModalV4 from '../components/ImageCropModalV4';

class Apresentacao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stations: [],
      stationImages: {},
      stationImageFiles: {},
      selectedStationsFromForm: [],
      currentSelectedStation: null,
      showCropModal: false,
      cropImageSrc: null,
      cropStationData: null,
      allGroupings: [],
      allCategories: [],
      loadingCategories: false,
    };
  }

  componentDidMount() {
    this.loadUserStations();
    this.loadCategoriesAndGroupings();
    if (this.props.formValues?.station_images) {
      this.setState({ stationImages: this.props.formValues.station_images });
    }
  }

  loadUserStations = () => {
    const establishments = this.props.auth?.user?.establishments || [];
    const allUserStations = [];
    
    establishments.forEach(establishment => {
      if (establishment.stations && Array.isArray(establishment.stations)) {
        establishment.stations.forEach(station => {
          if (!allUserStations.find(s => s.id === station.id)) {
            allUserStations.push(station);
          }
        });
      }
    });
    
    this.setState({ stations: allUserStations });
    return allUserStations;
  }

  loadCategoriesAndGroupings = async () => {
    const establishments = this.props.auth?.user?.establishments || [];
    const allStations = [];
    
    establishments.forEach(establishment => {
      if (establishment.stations && Array.isArray(establishment.stations)) {
        establishment.stations.forEach(station => {
          if (!allStations.find(s => s.id === station.id)) {
            allStations.push(station);
          }
        });
      }
    });

    if (allStations.length > 0) {
      this.setState({ loadingCategories: true });
      
      try {
        const { BASE_API } = require('config/consts');
        
        const fetchPromises = allStations.map(station => 
          fetch(
            `${BASE_API}/categories/?where[station_id]=${station.id}`,
            {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
              }
            }
          )
          .then(response => response.ok ? response.json() : null)
          .then(data => ({ station, categories: data?.content || data || [] }))
          .catch(err => {
            console.warn(`Erro ao carregar categorias da station ${station.id}:`, err);
            return { station, categories: [] };
          })
        );
        
        const results = await Promise.all(fetchPromises);
        
        // Agrupar categorias por station
        const allCategoriesGrouped = [];
        results.forEach(({ station, categories }) => {
          if (categories.length > 0) {
            // Adicionar categorias desta station
            categories.forEach(cat => {
              allCategoriesGrouped.push({
                id: cat.id,
                title: cat.name || cat.title,
                stationId: station.id,
                stationName: station.name,
              });
            });
          }
        });
        
        this.setState({ 
          allCategories: allCategoriesGrouped,
          loadingCategories: false 
        });
      } catch (error) {
        console.error('Erro ao carregar categorias:', error);
        this.setState({ loadingCategories: false });
      }
    }
  }

  handleFileSelect = (e) => {
    const file = e.target.files[0];
    const { currentSelectedStation } = this.state;
    
    if (file && currentSelectedStation) {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.setState({
          showCropModal: true,
          cropImageSrc: reader.result,
          cropStationData: currentSelectedStation
        });
      });
      reader.readAsDataURL(file);
    }
  };

  handleCropComplete = (imageId, file, croppedImageBase64) => {
    const { cropStationData } = this.state;
    
    if (cropStationData && imageId) {
      const newStationImages = {
        ...this.state.stationImages,
        [cropStationData.id]: imageId
      };
      
      this.setState({
        stationImages: newStationImages,
        stationImageFiles: {
          ...this.state.stationImageFiles,
          [cropStationData.id]: file
        },
        showCropModal: false,
        cropImageSrc: null,
        cropStationData: null,
        currentSelectedStation: cropStationData
      });

      this.props.change('station_images', newStationImages);
      this.props.change('image', imageId);
    }
  };

  handleCloseCropModal = () => {
    this.setState({
      showCropModal: false,
      cropImageSrc: null,
      cropStationData: null
    });
  };

  onSubmit = (values) => {
    if (values.categories_field) {
      values.categories = values.categories_field.map((item) => item.id);
    }
    values.groupings = [];

    if (this.state.stationImages && Object.keys(this.state.stationImages).length > 0) {
      this.props.change('station_images', this.state.stationImages);
      values.station_images = this.state.stationImages;
      
      const firstImagePath = Object.values(this.state.stationImages)[0];
      values.image = firstImagePath;
      this.props.change('image', firstImagePath);
    }
    this.props.onClickProgress();
  };

  render() {
    const { handleSubmit, formValues } = this.props;
    const { stations, stationImages, allCategories, loadingCategories } = this.state;
    const selectedStations = formValues?.stations_field || [];

    const categoryOptions = allCategories.filter(c => !c.isHeader).map(c => ({
      id: c.id,
      title: c.stationName ? `${c.title} (${c.stationName})` : c.title,
    }));

    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <div style={{ overflowY: 'scroll', height: 'calc(100vh - 355px)', padding: '0 10px' }}>
          {/* Categoria - Carregadas de todas as stations */}
          <div className="mb-3">
            <Field
              component={SelectMultipleV4}
              label="Categoria"
              name="categories_field"
              options={categoryOptions}
              helperText={loadingCategories ? "Carregando categorias..." : "Categorias de todas as suas stations"}
            />
          </div>

          {/* Título */}
          <div className="mb-3">
            <Field
              component={InputLabelOutlined}
              label="Título"
              name="body_name"
              placeholder="Nome dessa atividade"
              validate={[FORM_RULES.required]}
            />
          </div>

          {/* Descrição */}
          <div className="mb-3">
            <Field
              component={EditorConvertToHTMLActivity}
              label="Descrição"
              name="body_description"
              placeholder="Descreva sua atividade"
            />
          </div>

          {/* Publicar nas Stations */}
          <div className="mb-3">
            <Field
              component={SelectMultipleV4}
              label="Publicar nas Stations"
              name="stations_field"
              options={stations.map((s) => ({ id: s.id, title: s.name || s.title }))}
              helperText="Você pode selecionar mais de uma opção"
            />
          </div>

          {/* Imagens por Station */}
          {selectedStations.length > 0 && (
            <div className="mb-3">
              <Typography variant="subtitle2" gutterBottom>
                Clique em uma station para fazer upload da imagem:
              </Typography>
              <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
                {selectedStations.map((station) => {
                  const hasImage = stationImages[station.id];
                  return (
                    <div
                      key={station.id}
                      onClick={() => this.setState({ currentSelectedStation: station })}
                      style={{
                        padding: '8px 16px',
                        borderRadius: 16,
                        cursor: 'pointer',
                        backgroundColor: hasImage ? '#4caf50' : '#e0e0e0',
                        color: hasImage ? '#fff' : '#333',
                        border: this.state.currentSelectedStation?.id === station.id ? '2px solid #1976d2' : '2px solid transparent',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      {hasImage && <span>✓</span>}
                      {station.title || station.name}
                    </div>
                  );
                })}
              </Box>

              {this.state.currentSelectedStation && (
                <Box style={{ marginBottom: 16, padding: 16, border: '1px solid #e0e0e0', borderRadius: 8 }}>
                  <Typography variant="subtitle2" style={{ marginBottom: 16, fontWeight: 600 }}>
                    {this.state.currentSelectedStation.title || this.state.currentSelectedStation.name}
                  </Typography>
                  
                  {/* Preview da imagem se existir */}
                  {(this.state.stationImageFiles[this.state.currentSelectedStation.id] || stationImages[this.state.currentSelectedStation.id]) ? (
                    <div style={{ marginBottom: 16 }}>
                      <img
                        src={
                          this.state.stationImageFiles[this.state.currentSelectedStation.id]
                            ? URL.createObjectURL(this.state.stationImageFiles[this.state.currentSelectedStation.id])
                            : `https://s3.amazonaws.com/rilato.app.files/${stationImages[this.state.currentSelectedStation.id]}`
                        }
                        alt={`Preview ${this.state.currentSelectedStation.title || this.state.currentSelectedStation.name}`}
                        style={{
                          width: '100%',
                          maxHeight: 200,
                          objectFit: 'cover',
                          borderRadius: 8,
                        }}
                      />
                    </div>
                  ) : (
                    <Box
                      style={{
                        width: '100%',
                        height: 150,
                        backgroundColor: '#f5f5f5',
                        borderRadius: 8,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 16,
                      }}
                    >
                      <Typography variant="body2" color="textSecondary">
                        Nenhuma imagem selecionada
                      </Typography>
                    </Box>
                  )}
                  
                  {/* Input de arquivo */}
                  <input
                    type="file"
                    accept="image/*"
                    id="station-image-input"
                    style={{ display: 'none' }}
                    onChange={this.handleFileSelect}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => document.getElementById('station-image-input').click()}
                    fullWidth
                  >
                    {stationImages[this.state.currentSelectedStation.id] ? 'Trocar Imagem' : 'Selecionar Imagem'}
                  </Button>
                </Box>
              )}
            </div>
          )}

          {/* Imagem principal (fallback se não tiver stations) */}
          {selectedStations.length === 0 && (
            <div className="mb-3">
              <Field
                component={InputEasyImageWithProcessing}
                label="Imagem da Atividade"
                name="image"
                aspectRatio={16 / 9}
              />
            </div>
          )}
        </div>

        {/* Botões */}
        <MaterialGrid
          container
          display="flex"
          justifyContent="space-around"
          alignItems="center"
          style={{ margin: '25px 0px', overflowX: 'hidden' }}>
          <SecondaryButton
            type="button"
            color="secondary"
            onClick={this.props.handleOpenConfirmation}
            style={{ margin: 0, width: '48%', padding: '10px 20px', textTransform: 'none' }}>
            Voltar
          </SecondaryButton>
          <PrimaryButton
            type="submit"
            color="primary"
            style={{ margin: 0, width: '48%', padding: '10px 20px', textTransform: 'none' }}>
            Salvar e continuar
          </PrimaryButton>
        </MaterialGrid>

        {/* Modal de Crop de Imagem */}
        <ImageCropModalV4
          open={this.state.showCropModal}
          onClose={this.handleCloseCropModal}
          imageSrc={this.state.cropImageSrc}
          onCropComplete={this.handleCropComplete}
          stationName={this.state.cropStationData?.title || this.state.cropStationData?.name}
          aspect={16/9}
          aspectLabel="16:9"
        />
      </form>
    );
  }
}

Apresentacao.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  formValues: PropTypes.object,
  onClickProgress: PropTypes.func.isRequired,
  handleOpenConfirmation: PropTypes.func.isRequired,
  handleCancelClose: PropTypes.func.isRequired,
  openConfirmation: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  confirmationTitle: PropTypes.string,
  confirmationSubtitle: PropTypes.string,
  buttonConfirmationLabel: PropTypes.string,
  auth: PropTypes.object.isRequired,
  categories: PropTypes.object,
  change: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  categories: state.categories,
  formValues: getFormValues('vendasOnlineParceiroForm')(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCategoriesList,
      change: (field, value) => change('vendasOnlineParceiroForm', field, value),
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'vendasOnlineParceiroForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Apresentacao)
);
